import React from "react";
import { Redirect } from "react-router-dom";
import TraineeMasterData from "views/Trainee/TraineeMasterData.js";
import { checkDormitoryMasterDataPermission } from "./dormitoryAuth.js";

/**
 * DormitoryMasterData View
 * ระบบจัดการข้อมูลหลักของหอพัก (Master Data)
 * เงื่อนไข: ให้มองเห็นเฉพาะแท็บจัดการห้องพักและอาคาร (4 ตึก 3 ชั้น) เท่านั้น
 * และจำกัดสิทธิ์เฉพาะงานคอมพิวเตอร์และงานบริหาร
 */
export default function DormitoryMasterData() {
  const canManage = checkDormitoryMasterDataPermission();

  if (!canManage) {
    return <Redirect to="/dormitory/manage" />;
  }

  return <TraineeMasterData onlyRoomsTab={true} />;
}
